var _defs, _namedview, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 465.1619,
    height: 465.1619,
    viewBox: "0 0 349.22064 349.04525",
    id: "svg6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs10"
  })), _namedview || (_namedview = /*#__PURE__*/React.createElement("namedview", {
    id: "namedview8",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    pageshadow: 2,
    pageopacity: 0,
    pagecheckerboard: 0,
    showgrid: "false",
    "fit-margin-top": 0,
    "fit-margin-left": 0,
    "fit-margin-right": 0,
    "fit-margin-bottom": 0,
    zoom: 1.1599402,
    cx: 232.77062,
    cy: 243.11598,
    "window-width": 1920,
    "window-height": 1011,
    "window-x": 0,
    "window-y": 0,
    "window-maximized": 1,
    "current-layer": "svg6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 103.38654,15.171866 c 29.5,-13.4000008 62.8,-18.0000008 95,-13.7000008 32.7,4.3 64,18.3000008 89,39.8000008 24,20.2 42.3,46.999999 52.4,76.599994 11.6,33.7 12.5,71 2.6,105 a 176,176 0 0 1 -66.3,93.7 175,175 0 0 1 -68.6,29.5 c -42,8 -86.6,0.2 -123.000004,-22 -2.3,-1 -4.5,-3.5 -7.2,-2.4 l -63.899998,16.5 17,-62.4 c 1,-2.2 -1,-4 -2,-6 -19.3000002,-29.4 -29.30000016,-64.8 -28.30000016,-100 C 1.0865378,97.771865 47.086538,40.771866 103.08654,14.771866",
    fill: "#40c351",
    id: "path2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 113.58669,77.152883 c 4.7,0.1 7.8,4.3 9.6,8 6,13 10.8,26.399997 16.5,39.499997 1.2,2.7 2,5.7 1,8.6 -3,8.5 -10,14.6 -15.6,21.4 -2,2.3 -1.8,5.6 -0.2,8 a 130,130 0 0 0 73.5,63.5 c 3,1.3 6.6,1 8.7,-1.6 a 282,282 0 0 0 17,-20.9 c 4.6,-6 8.6,-4.3 14.6,-1.8 l 38.4,18.5 c 3,1.3 6,3.5 5.7,7 2,26 -21.3,46.2 -45.7,47 -63,-4.6 -106,-39.6 -137,-80 -10.2,-14.2 -21,-28.5 -26.6,-45.4 -5.3,-14.8 -5.5,-31.7 0.8,-46.3 9.7,-19.499997 18.2,-26.999997 39.6,-25.799997 z M 54.586685,2.5528837 C 100.78669,-30.447116 160.58669,-43.047116 216.58669,-31.847116 a 209,209 0 0 1 97.7,48.3 210,210 0 0 1 70.2,133.999996 211,211 0 0 1 -13,101 c -14.8,38 -41,71.4 -74.2,95 a 209,209 0 0 1 -109,38.5 210,210 0 0 1 -113,-25 l -112.000004,29 29.4999993,-108 c 0.6,-1.3 -0.3,-2.4 -1,-3.4 a 210,210 0 0 1 -24.9999993,-130 A 213,213 0 0 1 54.286685,2.5528837 M 103.98669,15.152884 c -33.5,15 -62.000005,40.8 -80.200005,72.699999 C 9.3866853,112.85288 1.3866853,141.35288 0.78668532,170.15288 c -1,35.2 8.99999998,70.5 28.29999968,100 1,1.8 2.8,3.7 2,6 l -17,62.4 c 21.3,-5.4 42.6,-11.2 64.000005,-16.6 2.7,-1 5,1.2 7.2,2.4 a 175,175 0 0 0 123,22.1 173,173 0 0 0 68.6,-29.5 176,176 0 0 0 66.3,-93.7 175,175 0 0 0 -2.6,-105 175,175 0 0 0 -52.4,-76.599996 174,174 0 0 0 -89.1,-39.8000003 c -32,-4.3 -65.4,0.3 -95,13.7000003 z",
    fill: "#fcfcfc",
    id: "path4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.400a9d9d008c467f77f1e3edd0d43575.svg";
export { ForwardRef as ReactComponent };